import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core';
import { RestMessage } from '@app/core/types';
import { CodeVerificationDTO } from '@app/core/types/user';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-recovery-code-verification',
  templateUrl: './recovery-code-verification-updated.component.html',
  styleUrls: ['./recovery-code-verification.component.sass'],
})
export class RecoveryCodeVerificationComponent implements OnInit {
  isVerified: boolean;
  recoveryForm: FormGroup;

  constructor(private router: Router, private authService: AuthenticationService) {
    this.recoveryForm = new FormGroup({
      userName: new FormControl('', [Validators.required]),
      code: new FormControl('', [Validators.required]),
    });
    this.recoveryForm.get('code')?.setValue('');
    this.recoveryForm.get('userName')?.setValue('');
    this.isVerified = false;
  }

  ngOnInit(): void {}

  get userName(): FormControl {
    return this.recoveryForm.get('userName') as FormControl;
  }

  get code(): FormControl {
    return this.recoveryForm.get('code') as FormControl;
  }

  onLogin() {
    this.authService.verifyRecoveryCode(this.recoveryForm.value).subscribe((res) => {
      if (res) {
        this.isVerified = true;
      }
    });
  }

  onBack() {
    //this.router.navigate(['/']);
    window.location.href = window.location.origin;
  }
}
